module.exports = __webpack_public_path__ + "img/default-placeholder.fbf55159.jpeg";